import BaseModel from '@/models/Base';
import Membership from '@/models/core/Membership';

export default class Source extends BaseModel {
  static entity = 'sources';

  static fields() {
    return {
      ...super.fields(),
      type: this.string(''),
      member_id: this.string(''),
      member: this.belongsTo(Membership, 'member_id')
    };
  }
}
